import {Route} from '@angular/router';
import {AuthGuard} from "../../shared/auth/auth.guard";
import {StatisticsPageComponent} from "./components/statistics-page/statistics-page.component";

export const StatisticsRoutes: Route[] = [
  {
    path: 'statistiken',
    component: StatisticsPageComponent,
    canActivate: [AuthGuard]
  }
];
